<div class="full-screen-bg">
	<div class="container container-sm">
		<div class="row">
			<div class="col-1"></div>
			<div class="col-10 rounded my-5 form-bg pb-2">
				<form *ngIf="step===1" role="form" [formGroup]="emailForm" #emailform="ngForm"
					(ngSubmit)="submitEmail()">
					<div class="row px-3">
						<div class="col">
							<h2 class="mt-4">Forgot your password?</h2>
							<div class="mt-2 mb-1">
								Please enter your registered email address.
								<br />
								We will send an OTP for verification.
							</div>
						</div>
					</div>
					<div class="row px-3">
						<div class="col-md-8">
							<div class="input-group mb-3">
								<span class="input-group-text" id="basic-addon1">
									<fa-icon [icon]="['fas', 'envelope']"></fa-icon>
								</span>
								<input id="email" formControlName="email" placeholder="Your email"
									class="form-control" />
							</div>
							<p *ngIf="f1.email.errors && (emailform.submitted || f1.email.touched || f1.email.dirty)"
								class="text-danger">
								<span *ngIf="f1.email.errors.required">
									Please enter email.
								</span>
								<span *ngIf="f1.email.errors.pattern">
									Please enter valid email! Eg. demo&#64;mail.com
								</span>
							</p>
						</div>
						<div class="col-md-4">
							<button id="sendResteId" [disabled]="emailForm.invalid || loadershow" type="submit"
								class="btn btn-outline-danger btn-block">
								<fa-icon *ngIf="loadershow" [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
								Get OTP
							</button>
						</div>
					</div>
					<div class="row px-3">
						<div *ngIf="resetPasswordError" class="col-sm-12">
							<div class="text-center">
								<h5 class="text-danger mb-0">{{resetPasswordError}}</h5>
							</div>
						</div>
					</div>
				</form>
				<form *ngIf="step===2" role="form" [formGroup]="otpForm" #otpform="ngForm" (ngSubmit)="submitOTP()">
					<div class="row px-3">
						<div class="col">
							<h2 class="mt-4">Forgot your password?</h2>
							<div class="mt-2 mb-1">
								Please enter the OTP received on your registered email address.
							</div>
						</div>
					</div>
					<div class="row px-3">
						<div class="col-md-8">
							<div class="input-group mb-3">
								<span class="input-group-text">
									<fa-icon [icon]="['fas', 'lock']"></fa-icon>
								</span>
								<input id="otp" formControlName="otp" placeholder="Enter OTP" class="form-control" />
							</div>
							<p *ngIf="f2.otp.errors && (otpform.submitted || f2.otp.touched || f2.otp.dirty)"
								class="text-danger">
								<span *ngIf="f2.otp.errors.required">
									Please enter OTP.
								</span>
								<span *ngIf="f2.otp.errors.pattern">
									OTP is 4 digits numeric.
								</span>
							</p>
						</div>
						<div class="col-md-4">
							<button id="sendResteId" [disabled]="otpForm.invalid || loadershow" type="submit"
								class="btn btn-outline-danger btn-block">
								<fa-icon *ngIf="loadershow" [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
								Verify
							</button>
						</div>
					</div>
					<div class="row px-3">
						<div *ngIf="resetPasswordError" class="col">
							<div class="text-center">
								<div class="text-danger">Invalid OTP</div>
							</div>
						</div>
					</div>
				</form>
				<form *ngIf="step===3" role="form" [formGroup]="recoverForm" #recform="ngForm"
					(ngSubmit)="submitForm()">
					<div class="row px-3">
						<div class="col">
							<h2 class="text-center mt-4">Reset your password</h2>
							<div class="mt-2 mb-1 text-center">
								Please choose a new password
							</div>
						</div>
					</div>
					<div class="row px-3">
						<div class="col-md-6">
							<div class="input-group mb-3">
								<span class="input-group-text">
									<fa-icon [icon]="['fas', 'lock']"></fa-icon>
								</span>
								<input id="password" placeholder="Password" type="password" formControlName="password"
									class="form-control" />
							</div>
							<div *ngIf="f3.password.errors && (recform.submitted || f3.password.touched || f3.password.dirty)"
								style="color: maroon;">
								<p *ngIf="f3.password.errors.required">
									Please enter something.
								</p>
								<p [ngClass]="f3.password.errors.minlengtherror?'text-danger':'text-success'">
									Password Must have 8 characters long.
								</p>
								<p [ngClass]="f3.password.errors.capitalerror?'text-danger':'text-success'">
									Password Must Have 1 Capital letter
								</p>
								<p [ngClass]="f3.password.errors.numericerror?'text-danger':'text-success'">
									Password must have 1 Numeric value
								</p>
								<p [ngClass]="f3.password.errors.digiterror?'text-danger':'text-success'">
									Must have atleast 1 digit.
								</p>
							</div>
						</div>
						<div class="col-md-6">
							<div class="input-group mb-3">
								<span class="input-group-text">
									<fa-icon [icon]="['fas', 'lock']"></fa-icon>
								</span>
								<input id="confirmPassword" placeholder="Confirm Password" type="password"
									formControlName="confirmPassword" class="form-control" />
							</div>
							<p class="text-danger"
								*ngIf="f3.confirmPassword.errors && (recform.submitted || f3.confirmPassword.touched || f3.confirmPassword.dirty)">
								<span *ngIf="f3.confirmPassword.errors.required">
									Please enter something.
								</span>
							</p>
							<p
								*ngIf="recform.errors && (recform.submitted || f3.confirmPassword.touched || f3.confirmPassword.dirty)">
								<span *ngIf="recform.errors.passwordNotMatch" class="text-danger">
									Password and Confirm Password not matched!
									<fa-icon [icon]="['fas', 'times']"></fa-icon>
								</span>
							</p>
						</div>
					</div>
					<div class="row px-3">
						<div class="col">
							<button id="resetSendId" [disabled]="recoverForm.invalid || loadershow" type="submit"
								class="btn btn-outline-danger btn-block">
								<fa-icon *ngIf="loadershow" [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
								Change Password
							</button>
						</div>
					</div>
					<div class="row px-3">
						<div *ngIf="resetPasswordError" class="col-sm-12">
							<div class="text-center">
								<h5 class="text-danger mb-0">{{resetPasswordError}}</h5>
							</div>
						</div>
					</div>
				</form>
				<form *ngIf="step===4" role="form">
					<h2 class="text-center" style="margin-top: 20px;">
						Your password is updated successfully.
						<a [routerLink]="['/login']">Click here</a> to login.
					</h2>
				</form>
				<div class="row px-3">
					<div class="col-sm-12 text-center text-black text-bold mt-2">
						Powered By
						<a href="http://3cubeservices.com/" target="_blank">3CUBE</a> © {{year}}
					</div>
				</div>
			</div>
			<div class="col-1"></div>
		</div>
	</div>
</div>